import { asBoolean, detectFeatureToggles } from '@rio-cloud/rio-uikit/urlFeatureToggles';

// Define toggle transformation functions with their respective names and
// export the detected feature toggles as a singleton

export const featureToggles = detectFeatureToggles({
    showMissingSampleMessage: asBoolean('ft_missingSampleMessage'),
});
